import { VisitationScheduleInterval } from "../models/VisitationScheduleInterval";

export const visitationScheduleIntervals: Record<
  VisitationScheduleInterval,
  { title: string }
> = {
  "1-week": { title: "1 Week" },
  "2-weeks": { title: "2 Weeks" },
  "3-weeks": { title: "3 Weeks" },
  "4-weeks": { title: "4 Weeks" },
  "5-weeks": { title: "5 Weeks" },
  "6-weeks": { title: "6 Weeks" },
  "7-weeks": { title: "7 Weeks" },
  "8-weeks": { title: "8 Weeks" },
};
